import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import companiesReducer from "./companiesSlice";
import careersReducer   from "./careersSlice";


import socialReducer from './socialSlice';
import blogReducer from "./blogSlice";
import seoReducer from "./seoSlice";




export const store = configureStore({
  reducer: {
    auth: authReducer,
    social: socialReducer,
    
      seo: seoReducer,
      blog: blogReducer,

      companies: companiesReducer,
    careers:   careersReducer,



  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
